import { render, staticRenderFns } from "./StartWorkflowForm.vue?vue&type=template&id=efaf2af2&scoped=true"
import script from "./StartWorkflowForm.vue?vue&type=script&lang=js"
export * from "./StartWorkflowForm.vue?vue&type=script&lang=js"
import style0 from "./StartWorkflowForm.vue?vue&type=style&index=0&id=efaf2af2&prod&lang=scss"
import style1 from "./StartWorkflowForm.vue?vue&type=style&index=1&id=efaf2af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaf2af2",
  null
  
)

export default component.exports